import { Command } from 'cmdk'
import { Loader2, Search, X } from 'lucide-react'
import { cn } from '../../lib/utils'

export function CommandPaletteInput({
  query,
  isDark,
  isSearching,
  onQueryChange,
  onClose,
}: {
  query: string
  isDark: boolean
  isSearching: boolean
  onQueryChange: (value: string) => void
  onClose: () => void
}) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 border-b px-4 py-3',
        isDark ? 'border-white/[0.06]' : 'border-neutral-200',
      )}
    >
      {isSearching ? (
        <Loader2
          className={cn(
            'h-4 w-4 shrink-0 animate-spin',
            isDark ? 'text-brand-400' : 'text-brand-500',
          )}
        />
      ) : (
        <Search
          className={cn('h-4 w-4 shrink-0', isDark ? 'text-neutral-500' : 'text-neutral-400')}
        />
      )}
      <Command.Input
        aria-label="Search and commands"
        value={query}
        onValueChange={onQueryChange}
        placeholder="Search documents or type a command..."
        className={cn(
          'flex-1 bg-transparent text-base outline-none md:text-sm',
          isDark
            ? 'text-neutral-100 placeholder-neutral-400'
            : 'text-neutral-900 placeholder-neutral-400',
        )}
      />
      <button
        type="button"
        aria-label="Close command palette"
        onClick={onClose}
        className={cn(
          'aw-command-palette-close cursor-pointer rounded-md p-0.5',
          isDark
            ? 'text-neutral-500 hover:text-neutral-300'
            : 'text-neutral-400 hover:text-neutral-600',
        )}
      >
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  )
}
